export default "__VITE_ASSET__bb549645__"